import { render } from "./FeaturedSlides.vue?vue&type=template&id=ad8d10b8"
import script from "./FeaturedSlides.vue?vue&type=script&lang=js"
export * from "./FeaturedSlides.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__